const SELECTOR = '.tmo-roi-card';
function onDocumentReady() {
	const els = document.querySelectorAll(SELECTOR);

	if (els) {
		[...els].map(el => new tmoROIcalculator(el));
	}
}

document.addEventListener('DOMContentLoaded', onDocumentReady);

// helper in global scope for ease of code readability
function isInt(value) {
	return !isNaN(value) && (function(x) { return (x | 0) === x; })(parseFloat(value))
}

class tmoROIcalculator {
	el;
	isDragging = false;
	lastDragged;
	numberOfLoans;
	averageLoanAmount;
	pctNonPerforming;
	hourlyLaborCost;
	totalCost;
	tmoCost;
	savingsShown;
	tmoYearlyCost;

	constructor(el) {
		this.el = el;
		const rangeInputs = el.querySelectorAll('.range-input');

		const rangeSliderValues = el.querySelectorAll('.range-slider-value');
		const rangeSliderMaxs = el.querySelectorAll('.range-slider-max');

		rangeSliderValues.forEach(v => this.formatLabel(v));
		rangeSliderMaxs.forEach(v => this.formatLabel(v));

		this.numberOfLoans = el.querySelector('.range-input.number_of_loans');
		this.averageLoanAmount = el.querySelector('.range-input.avg_loan_amount');
		this.pctNonPerforming = el.querySelector('.range-input.pct_non_performing');
		this.hourlyLaborCost = el.querySelector('.range-input.hourly_labor_cost');

		this.totalCost = el.querySelector('.total-cost');
		this.tmoCost = el.querySelector('.tmo-cost');
		this.savingsShown = el.querySelector('.savings-shown');

		this.tmoYearlyCost = el.dataset.tmoCost;

		this.calculate(); // get some numbers on the board

		// detect dragging range input interaction
		rangeInputs.forEach(i => { 
			i.addEventListener('input', this.calculate); // update value container
			i.addEventListener('input', this.watchRangeInput); // update value container
			i.addEventListener('pointerdown', this.listenRangeValue); // listen for range slide
		});

		// detect dragging range inputs
		document.addEventListener('pointermove', this.showRangeValue); // active range sliding
		document.addEventListener('pointerup', this.hideRangeValue); // deactivate range value container
	}

	watchRangeInput = (e) => {
		const input = e.target;
		const parent = input.parentNode;
		const sliderContainer = parent.parentNode;
		const value = input.value;
		const min = input.min;
		const max = input.max;
		const valueDisplay = parent.querySelector('.slider-value');
		const valueLabel = sliderContainer.querySelector('.range-slider-value');
		const valueWidth = valueDisplay.offsetWidth;
		const position = (value - min) / (max - min) * 100;

		valueDisplay.style.left = `calc(${position}% - ${valueWidth * 0.1}px)`;
		valueDisplay.innerHTML = this.numberWithCommas(value);
		valueLabel.innerHTML = this.numberWithCommas(value);
	}

	listenRangeValue = (e) => {
		const target = e.target;
		this.lastDragged = target;
		this.isDragging = true;
	}

	showRangeValue = () => {
		if (this.isDragging) {
			this.toggleRangeValue();
		}
	}

	hideRangeValue = () => {
		if (this.isDragging) {
			this.isDragging = false;
			this.toggleRangeValue(false);  // Ensure final update
		}
	}

	toggleRangeValue = (show = true) => {
		const parent = this.lastDragged.parentNode;
		const valueDisplay = parent.querySelector('.slider-value');

		if (!valueDisplay) {
			return;
		}

		if (show) {
			valueDisplay.classList.add('active');
		} else {
			valueDisplay.classList.remove('active');
		}
	}

	// MAIN CALCULATOR FUNCTIONS
	// These formulas were pulled from client supplied spreadsheet
	// you can view it in devin's google drive https://docs.google.com/spreadsheets/d/15kIh3KD-1tLoexgFT0iYfAHXoWjIw7jm/edit?gid=2087493227#gid=2087493227
	// vital design should have access.

	getEmployeeNumber = (numberOfLoans) => {
		return numberOfLoans / 100;
	}

	getYearlyLaborCost = (hlc_val) => {
		return hlc_val * 8 * 52 * 1.2;
	}

	getTotalNonPerforming = (nol_val, pnp_val) => {
		return nol_val * (pnp_val * 0.01);
	}

	getTotalPerformingLoans = (nol_val, pnp_val) => {
		const totalNonPerforming = this.getTotalNonPerforming(nol_val, pnp_val);

		return +nol_val - +totalNonPerforming;
	}

	// helper to getOutsourcingYearlyCost
	e2Switch(avg_loan_amount) {
		let ret;

		if (avg_loan_amount <= 50000) {
			ret = 35;
		} else if (avg_loan_amount <= 100000) {
			ret = 40;
		} else if (avg_loan_amount <= 200000) {
			ret = 45;
		} else if (avg_loan_amount <= 300000) {
			ret = 50;
		} else if (avg_loan_amount <= 400000) {
			ret = 55;
		} else if (avg_loan_amount <= 500000) {
			ret = 60;
		} else if (avg_loan_amount <= 750000) {
			ret = 65;
		} else if (avg_loan_amount <= 1000000) {
			ret = 70;
		} else if (avg_loan_amount <= 1500000) {
			ret = 75;
		} else if (avg_loan_amount > 1500000) {
			ret = 80;
		}

		return ret;
	}

	getOutsourcingYearlyCost = (ala_val, nol_val, pnp_val) => {
		const b6 = this.getTotalPerformingLoans(nol_val, pnp_val);
		const e2 = this.e2Switch(ala_val) * b6;
		const e3 = 115 * this.getTotalNonPerforming(nol_val, pnp_val);
		const f2 = e2 * 12;
		const f3 = e3 * 12;

		return +f2 + +f3;
	}

	getTMOCost = (tmoCost, yearlyCost) => {
		return +tmoCost + +yearlyCost;
	}

	calculate = () => {
		const nol_val = this.numberOfLoans.value;
		const ala_val = this.averageLoanAmount.value;
		const pnp_val = this.pctNonPerforming.value;
		const hlc_val = this.hourlyLaborCost.value;

		if (!nol_val || !isInt(nol_val)) {
			console.log('error { number of loans is undefined or not an integer');
			return;
		}

		if (!ala_val || !isInt(ala_val)) {
			console.log('error: average loan amount is undefined or not an integer');
			return;
		}
		if (!pnp_val || !isInt(pnp_val)) {
			console.log('error: percent non performing is undefined or not an integer');
			return;
		}
		if (!hlc_val || !isInt(hlc_val)) {
			console.log('error: hourly labor cost is undefined or not an integer');
			return;
		}

		const employees = this.getEmployeeNumber(nol_val);

		const yearlyCost = this.getYearlyLaborCost(hlc_val);

		const outsourcingYearlyCost = this.getOutsourcingYearlyCost(ala_val, nol_val, pnp_val);
		const tmoCost = this.getTMOCost(this.tmoYearlyCost, yearlyCost);

		const rawTotal = this.numberWithDecimal(outsourcingYearlyCost);
		const rawTMO = this.numberWithDecimal(tmoCost);
		const rawSavings = this.numberWithDecimal(outsourcingYearlyCost - tmoCost);

		this.totalCost.innerHTML = this.numberWithCommas(rawTotal);
		this.tmoCost.innerHTML = this.numberWithCommas(rawTMO);
		this.savingsShown.innerHTML = this.numberWithCommas(rawSavings);
	}

	// number formatting
	numberWithDecimal = (x) => {
		return Number(x).toFixed(2);
	}

	numberWithCommas = (x) => {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	formatLabel = (x) => {
		const value = x.innerHTML;
		x.innerHTML = this.numberWithCommas(value);
	}
}
